import module from 'module';
import _ from 'lodash';

const templateUrl = require('./organization.template.html');
module.component('organization', {
  templateUrl : templateUrl,
  controller: function ($scope, $location, authentication) {

    $scope.permission = authentication.permissions;

    $scope.isActive = function(route) {
      return route === $location.path();
    }
  }
});